module.exports = __webpack_public_path__ + "img/jgq_2.9f17c66f.webp";